import { useEffect, useRef } from "react";
import { useLogOut } from "hooks/useLogOut";

/**
 * The one web logout path (Header, sidebar, and Profile all link here).
 * Routes through useLogOut so the AuthSession is revoked SERVER-SIDE —
 * clearing localStorage alone would leave the JWT valid until expiry.
 */
export const Logout = () => {
    const logOut = useLogOut();
    const fired = useRef(false);

    useEffect(() => {
        if (fired.current) return;
        fired.current = true;
        // The revoke request is dispatched with keepalive inside useLogOut,
        // so it survives the immediate hard navigation.
        logOut();
        window.location.href = "/login";
    }, [logOut]);

    return null;
};
